export const WebCamInputBlockName = "WebCam";
export const TimeInputBlockName = "Time";
//# sourceMappingURL=blockNames.js.map